
import toast from 'react-hot-toast';
import './CartPageCss/CartTotalSection.css';
import { useNavigate } from 'react-router-dom';

const CartTotalSection = ({ price = 0, discount = 0, tax = 0 }) => {
    const navigator = useNavigate();

    const total = (price + tax - discount).toFixed(2);
    
    const handleAddMorePackage = (e) =>{
        e.preventDefault();
        // navigator('/OurPackagesPage');
        navigator('/test-packages')
    }

    const handleProceedPayment = (e) =>{
        // e.preventDefault();
        if(price <=0){
            // alert("Please add some test(s) to proceed");
            toast.error("Please add some test(s) to proceed");
            return;
        }
        // navigator('/collection');
        // navigator('/checkout')
        navigator('/home-collection');
    }

    return (
        <div className="cart-total-card">
            <h2 className="cart-title">Bill Summary</h2>
            <div className="cart-row">
                <span>M.R.P Total</span>
                <span>₹{price.toFixed(2)}</span>
            </div>
            {/* <div className="cart-row">
                <span>Price Discount</span>
                <span>- ₹{discount.toFixed(2)}</span>
            </div>
            <div className="cart-row">
                <span>Tax</span>
                <span>₹{tax.toFixed(2)}</span>
            </div> */}
            <hr />
            <div className="cart-row total-row">
                <span>TO BE PAID</span>
                <span className="total-price">₹{price.toFixed(2)}</span>
            </div>
             <button className="checkout-button rbdButton" onClick={handleAddMorePackage}><span className='btn-text'>Add More Test(s)</span></button>
            <button className="checkout-button rbdButton" onClick={handleProceedPayment}><span className='btn-text'>Proceed To Home Collection</span></button>
           
        </div>
    );
};

export default CartTotalSection;
